import React from 'react';
import { motion } from 'framer-motion';

const ConnectingDots = () => {
  // Define fixed positions for dots to cover the whole background
  const dots = [
    { id: 1, x: 10, y: 15 },
    { id: 2, x: 80, y: 25 },
    { id: 3, x: 25, y: 55 },
    { id: 4, x: 75, y: 75 },
    { id: 5, x: 90, y: 85 },
    { id: 6, x: 15, y: 90 },
    { id: 7, x: 40, y: 20 },
    { id: 8, x: 50, y: 65 },
    { id: 9, x: 95, y: 40 },
    { id: 10, x: 5, y: 45 },
  ];

  return (
    <motion.div
      className="fixed inset-0 pointer-events-none overflow-hidden opacity-30 dark:opacity-20 -z-10"
      animate={{
        x: [0, -15, 0],
        y: [0, -15, 0],
      }}
      transition={{
        duration: 25,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "linear"
      }}
    >
      <svg className="w-[110%] h-[110%] absolute -top-[5%] -left-[5%]">
        <defs>
          <marker id="arrow-cyan" viewBox="0 0 10 10" refX="15" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
            <path d="M 0 0 L 10 5 L 0 10 z" fill="currentColor" className="text-brand-cyan" />
          </marker>
          <marker id="arrow-yellow" viewBox="0 0 10 10" refX="15" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
            <path d="M 0 0 L 10 5 L 0 10 z" fill="currentColor" className="text-brand-yellow" />
          </marker>
        </defs>

        {/* Draw lines */}
        {dots.map((dot, i) => {
          const nextDot = dots[(i + 1) % dots.length];
          const targetDot1 = dots[(i + 2) % dots.length];

          return (
            <React.Fragment key={`lines-${i}`}>
              <motion.line
                x1={`${dot.x}%`}
                y1={`${dot.y}%`}
                x2={`${nextDot.x}%`}
                y2={`${nextDot.y}%`}
                stroke="currentColor"
                strokeWidth="1.5"
                strokeDasharray="8 8"
                className="text-brand-cyan"
                markerEnd="url(#arrow-cyan)"
                animate={{ strokeDashoffset: [240, 0] }}
                transition={{
                  duration: 10,
                  repeat: Infinity,
                  ease: "linear",
                }}
              />
              {(i % 3 === 0) && (
                 <motion.line
                  x1={`${dot.x}%`}
                  y1={`${dot.y}%`}
                  x2={`${targetDot1.x}%`}
                  y2={`${targetDot1.y}%`}
                  stroke="currentColor"
                  strokeWidth="1"
                  strokeDasharray="6 6"
                  className="text-brand-yellow"
                  markerEnd="url(#arrow-yellow)"
                  animate={{ strokeDashoffset: [240, 0] }}
                  transition={{
                    duration: 15,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                />
              )}
            </React.Fragment>
          );
        })}

        {/* Draw dots */}
        {dots.map((dot, i) => (
          <motion.circle
            key={`dot-${i}`}
            cx={`${dot.x}%`}
            cy={`${dot.y}%`}
            r="4"
            className="fill-brand-yellow drop-shadow-[0_0_8px_rgba(255,214,0,0.8)]"
            animate={{
              r: [4, 6, 4],
              opacity: [0.6, 1, 0.6]
            }}
            transition={{
              duration: 3 + (i % 3),
              repeat: Infinity,
              ease: "easeInOut",
              delay: i * 0.2
            }}
          />
        ))}
      </svg>
    </motion.div>
  );
};

export default ConnectingDots;
